export default __webpack_public_path__ + "static/principle-sentient-light-29c112fe654b05ed6573313fbc7a7b0663ec853238144e291cd0ab65ebee988e.png";